import { useTimezone } from '@app/core/hooks/useTimezone';
import { DateField } from '@mi-front/ui';
import { CalendarMonth as CalendarIcon } from '@mui/icons-material';
import { Grid } from '@mui/material';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';

export type Props = object;

export function SchedulesListMentionsIndexForm(p: Props) {
  const tz = useTimezone();
  const { $t } = useIntl();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={2}>
        <DateField
          label={$t({
            id: 'common.date',
            defaultMessage: 'Fecha',
          })}
          name="date"
          icon={<CalendarIcon />}
          max={moment(new Date()).tz(tz).format('YYYY-MM-DD')}
          isOutsideRange={(date) => moment(date) > moment()}
        />
      </Grid>
    </Grid>
  );
}
